import { render } from "./pageTool.vue?vue&type=template&id=66c65033&scoped=true"
import script from "./pageTool.vue?vue&type=script&lang=js"
export * from "./pageTool.vue?vue&type=script&lang=js"

import "./pageTool.vue?vue&type=style&index=0&id=66c65033&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-66c65033"

export default script